import React from "react";
import clsx from "clsx";
import useTranslate from "ui/locale/hooks/useTranslate";
import ScanQrWithButton from "ui/transactions/components/input/ScanQrWithButton/ScanQrWithButton";
import useClosePayModal from "../../PayModal/hooks/useClosePayModal";
import useQrScanNavigation from "ui/transactions/containers/PayModal/utils/useQrScanNavigation";

export interface PayTabProps {
    className?: string;
    style?: React.CSSProperties;
}

function PayTab({ className, ...rest }: PayTabProps) {
    const translate = useTranslate();
    const handleClose = useClosePayModal();
    const { navigateToTransactionTab } = useQrScanNavigation();

    function handlePay(qrCode: string | undefined) {
        navigateToTransactionTab(qrCode);
        handleClose();
    }

    return (
        <ScanQrWithButton
            className={clsx("pay-tab", className)}
            css={{ flex: 1 }}
            onScan={handlePay}
            onClick={handleClose}
            buttonLabel={translate("close")}
            {...rest}
        />
    );
}

export default PayTab;
